import { api } from '~/services/api';
import { AxiosError } from 'axios';

export type DeleteLineProps = {
  success: boolean;
};

type DeleteLineParams = {
  lineId: string;
};

type GetDeleteLineProps = {
  data?: DeleteLineProps;
  status?: number;
  message?: string;
};

type DeleteLineOptions = {
  initialData?: {
    data: DeleteLineProps;
  };
  keepPreviousData?: boolean;
};

export const deleteLine = async (
  params?: DeleteLineParams
): Promise<GetDeleteLineProps> => {
  try {
    const { lineId } = params as DeleteLineParams;
    const { data, status } = await api.delete(`/line/v1/lines/${lineId}`);

    return {
      data: data.data,
      status,
    };
  } catch (err) {
    const error = err as AxiosError;

    return {
      message: (error.response?.data as any).message,
      status: error.response?.status,
    };
  }
};
